import React from 'react';
import { NoRowsErrorOverlay } from '@/components/table/DataGridComponents/NoRowsOverlay';

const ContactsNoRowsErrorOverlay = () => (
	<NoRowsErrorOverlay objectType='relationshipContact' />
);

export default ContactsNoRowsErrorOverlay;
